/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Avoid deprecated APIs, use portals instead of rendering to a new root
 *	> 'render' import from 'owa-react-dom' is restricted. Use react portals instead of rendering into a new root */
import { render } from 'owa-react-dom';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { Panel } from '@fluentui/react/lib/Panel';
import React from 'react';
import { KnownIssuesFeedbackFormHeader, KnownIssuesFeedbackForm } from 'owa-smiley-feedback';
import { lazyRegisterAddDiagnosticCallback } from 'owa-diagnostic-report';
import { getSessionId } from 'owa-config';
import { getUserConfiguration } from 'owa-session-store';
import { bookwithmeCloseButtonAriaLabelForFeedbackPanel } from './Shared.locstring.json';
import loc from 'owa-localize';

function FeedbackPanel() {
    const [isOpen, setIsOpen] = React.useState(true);
    const dismissPanel = React.useCallback(() => setIsOpen(false), []);

    const dashboardLinkCallback = React.useCallback(() => {
        return {
            key: 'DiagnosticLogs',
            value: `https://jarvis-west.dc.ad.msft.net/dashboard/User%252Ftido?overrides=[{%22query%22:%22//*[id=%27sid%27]%22,%22key%22:%22value%22,%22replacement%22:%22${getSessionId()}%22},{%22query%22:%22//*[id=%27pid%27]%22,%22key%22:%22value%22,%22replacement%22:%22${
                getUserConfiguration()?.SessionSettings?.UserPuid
            }%22}]%20`,
        };
    }, []);

    React.useEffect(() => {
        lazyRegisterAddDiagnosticCallback.import().then(registerAddDiagnosticCallback => {
            registerAddDiagnosticCallback(dashboardLinkCallback);
        });
    }, []);

    return (
        <Panel
            isOpen={isOpen}
            onDismiss={dismissPanel}
            closeButtonAriaLabel={loc(bookwithmeCloseButtonAriaLabelForFeedbackPanel)}
        >
            <KnownIssuesFeedbackFormHeader />
            <KnownIssuesFeedbackForm onSendFeedback={dismissPanel} />
        </Panel>
    );
}

export default function renderFeedbackPanel() {
    const featureFlagsDiv = document.createElement('div');
    window.document.body.appendChild(featureFlagsDiv);

    render(
        <ThemeProvider role={'complementary'} tabIndex={-1}>
            <FeedbackPanel />
        </ThemeProvider>,
        featureFlagsDiv
    );
}
